import {CONSTANTS} from '@/constants'

export default function(h, row, index) {
    let _name_correct = ''
    if ((row.surname_correct != null)&&(row.surname_correct != '')) {
        _name_correct += row.surname_correct;
    }
    if ((row.name_correct != null)&&(row.name_correct != '')) {
        if (_name_correct) _name_correct = _name_correct + ' '
        _name_correct += row.name_correct;
    }
    if ((row.patro_correct != null)&&(row.patro_correct != '')) {
        if (_name_correct) _name_correct = _name_correct + ' '
        _name_correct += row.patro_correct;
    }

    let _name = ''
    if ((row.surname != null)&&(row.surname != '')) {
        _name += row.surname;
    }
    if ((row.name_ != null)&&(row.name_ != '')) {
        if (_name) _name = _name + ' '
        _name += row.name_;
    }
    if ((row.patro != null)&&(row.patro != '')) {
        if (_name) _name = _name + ' '
        _name += row.patro;
    }

    if (!_name) _name = 'Имя не указано'
    if (!_name_correct) _name_correct = 'Имя не указано'

    let __name = ''

    if ((_name ===_name_correct)||(_name === 'Имя не указано'))
        __name = <span><span class="orders_table__contact_name">{_name_correct}</span></span>
    else
        __name = <span><span class="orders_table__contact_name">{_name_correct}</span><br/>(<span class="orders_table__contact_name_old">{_name}</span>)</span>

    let _comment = ''

    if (row.other_text_correct) {
        if (_comment) _comment = <span>{_comment}<br/></span>
         _comment = <span>{_comment}<span title="Комментарий заказчика"><strong>З:</strong> {row.other_text_correct}</span></span>
    }

    if (row.comment_manager) {
        if (_comment) _comment = <span>{_comment}<br/></span>
        _comment = <span>{_comment}<span title="Комментарий менеджера"><strong>М:</strong> {row.comment_manager}</span></span>
    }

    if ((row.comment_wait)&&(row.status_index===CONSTANTS.ORDER_STATUS_POSTPONED)) {
        if (_comment) _comment = <span>{_comment}<br/></span>
        _comment = <span>{_comment}<span title="Причина отправки в ожидание"><strong>О:</strong> {row.comment_wait}</span></span>
    }

    if ((row.comment_close)&&(row.status_index===CONSTANTS.ORDER_STATUS_ARCHIVED)) {
        if (_comment) _comment = <span>{_comment}<br/></span>
        _comment = <span>{_comment}<span title="Причина отправки в архив"><strong>А:</strong> {row.comment_close}</span></span>
    }

    return <span>{__name}<br/>{_comment}</span>

}